module.exports = __webpack_public_path__ + "img/crown2.57e481b7.svg";